module.exports = "/_next/static/images/video_id_7178877810029694251-8ea75db156e45c08bd8eeb499da2fc5d.jpg";